import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsAdminSkillsPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="admin-skills"
    />
  );
}
